/** 서버에서 받은 목록의 구조·순서는 유지하고 해당 공고의 관심 표시만 바꾼다. */
export type FavoriteSnapshotChange =
    | { kind: 'clinic'; clinicId: number; isFavorite: boolean }
    | { kind: 'recruitment'; recruitmentId: number; isFavorite: boolean; favoriteCount: number };

export function patchFavoriteSnapshot<T>(data: T, change: FavoriteSnapshotChange): T {
    if (Array.isArray(data)) {
        const items = data.map((item) => patchFavoriteSnapshot(item, change));
        return (items.some((item, index) => item !== data[index]) ? items : data) as T;
    }
    if (data === null || typeof data !== 'object') return data;
    const record = data as Record<string, unknown>;
    const clinic = (record.clinic ?? record.dentalClinic) as { id?: number } | undefined;
    let updated = record;
    if (clinic && change.kind === 'clinic' && clinic.id === change.clinicId && record.isFavoriteClinic !== change.isFavorite) {
        updated = { ...record, isFavoriteClinic: change.isFavorite };
    }
    if (clinic && change.kind === 'recruitment' && record.id === change.recruitmentId) {
        updated = { ...record, isFavorited: change.isFavorite, favoriteCount: change.favoriteCount };
    }
    for (const [key, value] of Object.entries(record)) {
        const patched = patchFavoriteSnapshot(value, change);
        if (patched !== value) {
            if (updated === record) updated = { ...record };
            updated[key] = patched;
        }
    }
    return updated as T;
}
